import { QUIZ_QUERY_PARAMS } from '@mc/find-my-classes'
import { paths } from '@mc/paths'
import { AI_MOTIVATION_QUERY_PARAM } from 'pages/find-my-classes/hooks/useCategorySelections'

type CtaPathOptions = {
  skipQ1?: boolean
  categories?: number[]
  ai?: boolean
}

export const ctaPath = ({ skipQ1, categories, ai }: CtaPathOptions) => {
  const base = paths.classRecommendations

  const qp = new URLSearchParams()

  if (categories?.length) {
    qp.set(QUIZ_QUERY_PARAMS.SELECTED_CATEGORIES, categories.join(','))
  }
  if (skipQ1) {
    qp.set(QUIZ_QUERY_PARAMS.SKIP_Q1, 't')
  }
  if (ai) {
    qp.set(AI_MOTIVATION_QUERY_PARAM, 'true')
  }

  const hasParams = [...qp.keys()].length === 0

  return base + (hasParams ? '' : `?${qp.toString()}`)
}
